import visa from '@/views/visa/index.vue'
export const visaRouter = [
  {
    path: `/visa/index`,
    name: 'visa',
    component: visa,
  },
]
